import { SVGProps } from 'react';

export const SvgStickyNote = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={24}
    width={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.42861 0C7.82309 0 8.14289 0.316034 8.14289 0.705882V4.09411C8.14289 4.48396 7.82309 4.8 7.42861 4.8C7.03412 4.8 6.71432 4.48396 6.71432 4.09411V0.705882C6.71432 0.316034 7.03412 0 7.42861 0Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.5714 0C16.9659 0 17.2857 0.316034 17.2857 0.705882V4.09411C17.2857 4.48396 16.9659 4.8 16.5714 4.8C16.177 4.8 15.8572 4.48396 15.8572 4.09411V0.705882C15.8572 0.316034 16.177 0 16.5714 0Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.57148 10.8707C5.57148 10.4808 5.89128 10.1648 6.28577 10.1648H15.4286C15.8231 10.1648 16.1429 10.4808 16.1429 10.8707C16.1429 11.2605 15.8231 11.5766 15.4286 11.5766H6.28577C5.89128 11.5766 5.57148 11.2605 5.57148 10.8707Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.57148 15.3883C5.57148 14.9984 5.89128 14.6824 6.28577 14.6824H12C12.3945 14.6824 12.7143 14.9984 12.7143 15.3883C12.7143 15.7781 12.3945 16.0941 12 16.0941H6.28577C5.89128 16.0941 5.57148 15.7781 5.57148 15.3883Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.38788 1.69531C7.40143 1.69454 7.41499 1.69416 7.42857 1.69416H16.5714C16.5843 1.69416 16.5971 1.69451 16.61 1.69519C18.5726 1.80003 20.2415 2.22756 21.3869 3.48673C22.5196 4.73201 23 6.63858 23 9.34592V16.5177C23 16.9075 22.6802 17.2236 22.2857 17.2236C21.8912 17.2236 21.5714 16.9075 21.5714 16.5177V9.34592C21.5714 6.74503 21.0975 5.28031 20.3245 4.43053C19.5668 3.59753 18.3841 3.20605 16.5519 3.10593H7.44915C5.61603 3.21164 4.43306 3.60305 3.67517 4.43512C2.9025 5.28341 2.42857 6.74508 2.42857 9.34592V16.3144C2.42857 18.6309 2.72546 20.1396 3.54437 21.0922C4.33751 22.0149 5.78099 22.5883 8.57142 22.5883H15.4286C15.823 22.5883 16.1428 22.9043 16.1428 23.2941C16.1428 23.684 15.823 24 15.4286 24H8.57142C5.64757 24 3.66248 23.4101 2.45563 22.0062C1.27454 20.6323 1 18.6511 1 16.3144V9.34592C1 6.63853 1.48036 4.73455 2.6134 3.49062C3.75845 2.23349 5.42675 1.80589 7.38788 1.69531Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.7908 17.8638C16.4006 18.2495 16.1429 18.8853 16.1429 19.9059V21.59L20.5613 17.2235H18.8572C17.8244 17.2235 17.1811 17.4782 16.7908 17.8638ZM15.7807 16.8656C16.5333 16.1218 17.6042 15.8118 18.8572 15.8118H22.2857C22.5746 15.8118 22.8351 15.9838 22.9457 16.2475C23.0562 16.5113 22.9951 16.8149 22.7908 17.0168L15.9337 23.7932C15.7294 23.9951 15.4222 24.0555 15.1553 23.9463C14.8884 23.837 14.7143 23.5796 14.7143 23.2941V19.9059C14.7143 18.6677 15.028 17.6093 15.7807 16.8656Z"
    />
  </svg>
);
